import { FitifyIcon } from 'fitify-ui/src/Icon/custom/FitifyIcon'

import { StyledLogoWrapper } from './Logo.Styled'

type Props = {
  className?: string
}

export const Logo = ({ className }: Props) => {
  return (
    <StyledLogoWrapper className={className}>
      <FitifyIcon aria-label="Fitify logo" />
    </StyledLogoWrapper>
  )
}
